module.exports = __webpack_public_path__ + "static/img/frost.9f96faf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/neutral/frost.png
// module id = cbMc
// module chunks = 0